import { Core } from 'chessboard/core/config/types';
import { isOneOf } from 'utils/app/model/is-one-of';
import { Pieces } from 'chessboard/plugins/pieces/config/types';
import type { Plugins } from 'chessboard/core/plugins/config/types';
import { is } from 'src/utils/app/model/is';

/**
 * Adds commands for making moves on the board.
 */
export function createPiecesPlugin(): Plugins.Model {
  return {
    match: [
      {
        condition: isOneOf(Core.APIEvents),
        handler: updatePieces,
      },
      {
        condition: is(Core.InstanceEvents.RendererSet),
        handler: reloadPieces,
      },
    ],
    name: Pieces.Plugin.Name,
  };

  /**
   * Reload the pieces directly from the api.
   */
  function reloadPieces(_event: Core.Event, context: Core.Context) {
    const { api, renderer } = context;

    renderer?.loadPieces({ pieces: api.getPieces() }, context);
  }

  /**
   * Update the board pieces.
   */
  function updatePieces(event: Core.Event, context: Core.Context) {
    const { renderer } = context;

    if (!renderer) {
      return;
    }

    if (event.type === Core.APIEvents.IllegalMove) {
      renderer.illegalMove(false, context);

      return;
    }

    const { plyDiff, move, pieces } = event.data;

    if (pieces) {
      renderer.loadPieces({ pieces }, context);

      return;
    }

    if (move && plyDiff === -1) {
      if (move.san !== '--') {
        renderer.undoMove(move, context);
      }

      return;
    }

    if (move) {
      renderer.makeMove(move, context);
    }
  }
}
